// extracted by mini-css-extract-plugin
export default {"btn":"filter-view_btn__2qaM6","filter_count":"filter-view_filter_count__wglYw"};